import { CDS_FP_ERROR_KEYS } from '../constants/cdsFrequentPassenger';

/**
 * Formats a CDS Pasajero Frecuente error for display.
 * Known keys are translated; API messages (e.g. 422) are shown as-is.
 * @param {Function} t - i18next translate function for cdsFrequentPassenger namespace.
 * @param {string|null|undefined} error
 * @returns {string|null}
 */
export default function formatCdsFpErrorMessage(t, error) {
  if (!error) return null;
  if (CDS_FP_ERROR_KEYS.has(error)) return t(error);
  return error;
}
